import React, { useEffect, useState } from "react";

import dsdeApi from "apis/dsde";
import { Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

import { DSDE_REFERENCE_OVERVIEW_FIELDS } from "./constants";

const DsdeReferenceOverview = ({ associatedReferenceSource }) => {
  const [dsdeCount, setDsdeCount] = useState(0);

  const fetchDsdeCount = async () => {
    const { data } = await dsdeApi.fetch();
    setDsdeCount(data?.dsdes?.dsde_count);
  };

  useEffect(() => {
    fetchDsdeCount();
  }, []);

  const referenceSourceMappedToDsdePercentage = () =>
    ((associatedReferenceSource?.dsde_mapped_count * 100) / dsdeCount)
      .toFixed(2)
      .replace(/\.00$/, "");

  return (
    <ContentBox className="w-1/3">
      <ContentBox className="mt-2">
        <Typography style="h4" type="semibold" className="mb-4">
          Reference Source Overview
        </Typography>
        {DSDE_REFERENCE_OVERVIEW_FIELDS.map(({ label, value }) => (
          <Typography
            key={value}
            className="border-b border-gray-300 px-1 pt-1 pb-2"
          >
            {label}
            <Typography
              key={value}
              className="ml-2 font-semibold text-indigo-600 dark:text-indigo-500 inline"
              type="semibold"
            >
              {associatedReferenceSource?.[value]}
            </Typography>
          </Typography>
        ))}
        <Typography className="px-1 pt-1 pb-2">
          Reference Sources Mapped to
          <Typography
            className="ml-2 font-semibold text-indigo-600 dark:text-indigo-500 inline"
            type="semibold"
          >
            {referenceSourceMappedToDsdePercentage()}%
          </Typography>
        </Typography>
      </ContentBox>
    </ContentBox>
  );
};

export default DsdeReferenceOverview;
